export default __webpack_public_path__ + "static/media/clear.154fde61.svg";